import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { navigate } from '@reach/router';
import PATHS from 'src/utils/paths'

import Ellipse14 from 'src/assets/images/vectors/ellipse-14.svg'
import Ellipse15 from 'src/assets/images/vectors/ellipse-15.svg'

import {
  round1,
  round2
} from 'src/components/AnimationKeyframes'
import ContactFormModal from 'src/components/ContactFormModal'

import Button from 'src/components/atoms/Button'

export const HistorySection = (props) => {
  const { t } = useTranslation()
  const [contactFormModalOpen, setContactFormModalOpen] = useState(false);

  return (
    <HistorySectionContainer>
        <div className='history-section__container'>
            <div className='history-section__images'>
                <img src={Ellipse14} alt='ellipse-14' className='ellipse-14' />
                <img src={Ellipse15} alt='ellipse-15' className='ellipse-15' />
            </div>
            <div className='history-section__title'>
                <h1>
                    <span>{t('landingPage.historySection.titleText1')}</span>
                    <br />
                    <span>{t('landingPage.historySection.titleText2')}?</span>
                </h1>
            </div>
            <div className='history-section__content'>
                <p>{t('landingPage.historySection.subtitleText1')}</p>
                <p>{t('landingPage.historySection.subtitleText2')}</p>
                <p>{t('landingPage.historySection.subtitleText3')}</p>
            </div>
            <div className='buttons__container'>
                <Button onClick={() => setContactFormModalOpen(true)} size='large'>{t('landingPage.historySection.iWantPanda')}</Button>
                <Button onClick={() => navigate(PATHS.logIn)} size='large' color='secondary'>{t('landingPage.historySection.logIn')}</Button>
            </div>
        </div>
        <ContactFormModal open={contactFormModalOpen} onClose={() => setContactFormModalOpen(false)} />
    </HistorySectionContainer>
  )
}

export default HistorySection

const HistorySectionContainer = styled.div`
    .history-section__container {
        color: ${props => props.theme.palette.common.black};
        text-align: center;
        background-color: ${props => props.theme.palette.background.paper};
        padding-top: 32px;
        padding-left: 20px;
        padding-right: 20px;
        margin: 0 auto;
        max-width: 844px;

        .history-section__images {
            height: 0;
            position: relative;

            ${props => props.theme.breakpointsMedia.mobile} {
                display: none;
            }

            img {
                position: absolute;

                &.ellipse-14 {
                    top: 30px;
                    right: 0;
                    animation: ${round1} 3s linear infinite;
                }

                &.ellipse-15 {
                    top: 300px;
                    left: -50px;
                    animation: ${round2} 4s linear infinite;
                }
            }
        }

        .history-section__title {
            h1 {
                font-size: 30px;

                span:nth-child(1) {
                    font-weight: 800;
                }

                span:nth-child(3) {
                    font-weight: 300;
                }

                ${props => props.theme.breakpointsMedia.desktop} {
                    span:nth-child(1) {
                        font-size: 36px;
                    }

                    span:nth-child(3) {
                        font-size: 48px;
                    }
                }
            }
        }

        .history-section__content {
            font-size: 18px;
            font-weight: 500;
            line-height: 1.5;

            p {
                margin-top: 32px;
            }
        }

        .buttons__container {
            margin-top: 32px;
            width: 100%;
            display: flex;
            flex-direction: column;

            ${props => props.theme.breakpointsMedia.desktop} {
                flex-direction: row;
                justify-content: center;
                gap: 32px;
            }

            button {
                border: none;
                width: 160px;
                margin: 0 auto;

                ${props => props.theme.breakpointsMedia.desktop} {
                    margin: 0;
                }

                &:nth-child(2) {
                    margin-top: 32px;
                    width: 275px;

                    ${props => props.theme.breakpointsMedia.desktop} {
                        margin-top: 0;
                    }
                }
            }
        }
    }
`
